import { render, staticRenderFns } from "./LayersPanel.vue?vue&type=template&id=32815650&scoped=true&"
import script from "./LayersPanel.vue?vue&type=script&lang=js&"
export * from "./LayersPanel.vue?vue&type=script&lang=js&"
import style0 from "./LayersPanel.vue?vue&type=style&index=0&id=32815650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32815650",
  null
  
)

export default component.exports